import { Shield } from "lucide-react";
import { Badge } from "@/components/common";
import type { Role } from "@/types/rbac";

interface RoleBadgeProps {
  role: Pick<Role, "name" | "isSystem">;
}

export function RoleBadge({ role }: RoleBadgeProps) {
  return (
    <Badge variant="brand">
      {role.isSystem && (
        <Shield size={12} className="shrink-0" aria-hidden="true" />
      )}
      {role.name}
    </Badge>
  );
}
